import React from 'react'
import { Divider, Typography, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Species from './Species'
import { FormattedMessage } from 'react-intl'
import ResearchAreas from './ResearchAreas/ResearchAreas'
import { useFormikContext } from 'formik'
import { MilliplexFormValues } from '../Milliplex'
import messages from '../../../messages'
import GlobalAlert from '@src/components/GlobalAlert'
import Assays from './Assays'
import { SpeciesItem, AssayTypeItem } from '@src/types/graphql-types'
import HandleMarkup from '@src/components/HandleMarkup'

const useStyles = makeStyles((theme: Theme) => {
  return {
    errorAlert: {
      marginTop: theme.spacing(6),
    },
  }
})

export interface MilliplexStep1Props {
  displayPageError: boolean
  setDisplayPageError: React.Dispatch<React.SetStateAction<boolean>>
  speciesList: string[]
  listResearchAreas: SpeciesItem[]
  assayTypeList: AssayTypeItem[]
  loadingSearchCriteriaList: boolean
}
const MilliplexStep1: React.FC<MilliplexStep1Props> = ({
  displayPageError,
  setDisplayPageError,
  speciesList,
  listResearchAreas,
  assayTypeList,
  loadingSearchCriteriaList,
}) => {
  const classes = useStyles()
  const formik = useFormikContext<MilliplexFormValues>()

  return (
    <>
      <Typography variant="h2">
        <HandleMarkup value={'MILLIPLEX<sup>®</sup>'} />
        <FormattedMessage
          id="CONF_ANALYTE_KIT_FINDER"
          defaultMessage="Analyte Kit Finder"
        />
      </Typography>
      {displayPageError && (formik.errors.species || formik.errors.assay) && (
        <GlobalAlert severity="error" className={classes.errorAlert}>
          <FormattedMessage {...messages.CONF_DNAPLATES_ERROR_STEP2} />
        </GlobalAlert>
      )}
      <Species
        listSpecies={speciesList}
        loading={speciesList.length === 0 && loadingSearchCriteriaList}
        setDisplayPageError={setDisplayPageError}
        assayTypeList={assayTypeList}
      />
      <Divider style={{ marginTop: '24px' }} />
      <ResearchAreas
        listResearchAreas={listResearchAreas}
        loading={loadingSearchCriteriaList}
        setDisplayPageError={setDisplayPageError}
        assayTypeList={assayTypeList}
      />
      <Divider style={{ marginTop: '24px' }} />
      <Assays
        assayTypeList={assayTypeList}
        loading={loadingSearchCriteriaList}
        setDisplayPageError={setDisplayPageError}
      />
    </>
  )
}

export default MilliplexStep1
